import React from "react";
import { Line } from "react-chartjs-2";

/**
 * CountByDayReport
 *
 * Renders a line chart of counts by day of week, plus a print-only details table.
 *
 * Props:
 * - chartData: { labels: string[], datasets: Array<{ data: number[] }> }
 * - chartOptions: object
 * - storess: string         // store name
 * - range: { tran_date: { $gte: string, $lte: string } }
 * - chartRef: React.RefObject
 * - containerId: string     // id for the outer div
 */
const CountByDayReport = ({
  chartData,
  chartOptions,
  storess,
  range,
  chartRef,
  containerId,
}) => {
  const startDate = range?.tran_date?.$lte?.split("T")[0] || "";
  const endDate = range?.tran_date?.$gte?.split("T")[0] || "";

  return (
    <div ref={chartRef} id={containerId}>
      <div className="card">
        <Line data={chartData} options={chartOptions} />
      </div>

      <div className="print-only-content">
        <h2>Report Details</h2>
        <div className="d-flex justify-content-between align-items-center print-only-content">
          <h3>Brand: Angels Pizza</h3>
          <h4 className="mx-auto"></h4>
          <h3>Store: {storess}</h3>
          <h3>Date: {`${startDate} ${endDate}`}</h3>
        </div>

        <div style={{ fontSize: "20px" }}>
          <table className="table text-center">
            <thead>
              <tr className="d-flex">
                <th>Day</th>
                <th className="ms-5">Count</th>
              </tr>
            </thead>
            <tbody>
              {chartData.labels.map((label, index) => (
                <tr className="d-flex" key={`${containerId}-${label}`}>
                  <td>{label}</td>
                  <td>{chartData.datasets[0].data[index]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CountByDayReport;
